const routePreloaders = {
  "/": () => import("@/pages/Index"),
  "/beratung": () => import("@/pages/Beratung"),
  "/wissen": () => import("@/pages/Wissen"),
  "/plattform": () => import("@/pages/DealRoomDemo"),
  "/faq": () => import("@/pages/Faq"),
  "/glossar": () => import("@/pages/Glossar"),
  "/ressourcen": () => import("@/pages/Ressourcen"),
  "/investitionsrechner": () => import("@/pages/Calculator"),
  "/impressum": () => import("@/pages/Impressum"),
} as const;

const loadedRoutes = new Set<string>();

const scheduleIdle = (cb: () => void) => {
  if (typeof window === "undefined") return;
  const ric = (window as unknown as { requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number }).requestIdleCallback;
  if (typeof ric === "function") {
    ric(cb, { timeout: 2000 });
  } else {
    setTimeout(cb, 200);
  }
};

export const preloadRoute = (route: keyof typeof routePreloaders | string) => {
  const loader = routePreloaders[route as keyof typeof routePreloaders];
  if (!loader || loadedRoutes.has(route)) return;

  loadedRoutes.add(route);
  // Fire immediately — on mobile pointerdown/touchstart fires ~100-300ms before
  // the actual click, giving the chunk a head start.
  void loader();
};

/** Use for hover/focus on desktop — defers via idle to avoid hurting current interaction. */
export const preloadRouteIdle = (route: keyof typeof routePreloaders | string) => {
  const loader = routePreloaders[route as keyof typeof routePreloaders];
  if (!loader || loadedRoutes.has(route)) return;

  loadedRoutes.add(route);
  scheduleIdle(() => {
    void loader();
  });
};

// Intentionally a no-op: aggressive preloading on the homepage caused the
// initial bundle to balloon and stall first paint. Routes are now only
// prefetched on hover/focus/touch via preloadRoute().
export const preloadCriticalRoutes = () => {
  // no-op
};
